<template>
    <div class="upload-backup-container">
        <div class="img-container">
            <img src="/static/images/backup_upload.png" alt="backup icon">
        </div>

        <form :action="route('library.backups.upload')" method="POST" enctype='multipart/form-data'>
            <input name="_token" type="hidden" :value="csrfToken">
            <app-input type="file" name="library_backup" class="mb-2" accept=".zip"></app-input>

            <app-button submit="true" type="primary">Upload</app-button>
            <app-button @click="cancel">Cancel</app-button>
        </form>
    </div>
</template>

<script>
export default {
    computed: {
        csrfToken() {
            return document.querySelector('meta[name="csrf-token"]').content;
        }
    },
    methods: {
        cancel() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
.upload-backup-container {
    margin: 0.75rem;

    & > div.img-container {
        margin: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;

        & > img {
            width: 100px;
        }
    }

    & > button {
        margin-top: 0.75rem;
    }
}
</style>
<script setup>
</script>
